import React from "react";
import DataSummaryTable from "../components/table/DataSummaryTable";
import { useGetCorporatePlansSummaryQuery } from "../redux/service/modules/dashboard";
import { customCellColor, getHighlightStyle } from "../utils/commonUtils";
import { useLazyGetLazyCorporatePlansSummaryQuery } from "../redux/service/modules/dashboard/lazzyQuery";

const CorporatePlansSummaryTable = ({ initialDateRange, filters }) => {
    const highlightRules = [
        {
            column: "row_color",
            condition: "customRowColor",
            fetchCustomRowColor: (row) => getHighlightStyle(row.row_color),
        },
    ];

    const columnTypeMapping = {
        corporate_roadshow: {
            columns: [
                "corporate_roadshow_planned",
                "corporate_roadshow_actual",
                "corporatendr_lag",
            ],
            colorKey: "corporate_roadshow_color",
        },
        expert_roadshow_planned: {
            columns: ["expert_roadshow_planned", "expert_roadshow_actual", "expertndr_lag"],
            colorKey: "expert_roadshow_color",
        },
        conference: {
            columns: [
                "conference_planned",
                "conference_actual",
                "conference_lag",
            ],
            colorKey: "conference_color",
        },
        plant_visit_site_visit: {
            columns: ["plant_visit_site_visit_planned", "plant_visit_site_visit_actual", "events_lag"],
            colorKey: "plant_visit_site_visit_color",
        },
        expert_meeting: {
            columns: ["expert_meeting_planned","expert_meeting_actual",  ],
            colorKey: "expert_meeting_color",
        },
        expert_series: {
            columns: ["expert_series_planned","expert_series_actual"  ],
            colorKey: "expert_series_color",
        },
        corporate_meeting: {
            columns: ["corporate_meeting_planned","corporate_meeting_actual",  ],
            colorKey: "corporate_meeting_color",
        },
        ambit_acuity: {
            columns: ["ambit_acuity_planned","ambit_acuity_actual",  ],
            colorKey: "ambit_acuity_color",
        },
    };

    const [exportToExcelQuery] = useLazyGetLazyCorporatePlansSummaryQuery();

    return (
        <DataSummaryTable
            title="Corporate Access Summary"
            initialDateRange={initialDateRange}
            queryHook={useGetCorporatePlansSummaryQuery}
            maxRows={5}
            headerFontSizes={["18px", "14px", "0px"]}
            headerHeights={["1.5rem", "1rem", "1rem"]}
            headerPadding={["8px 5px", "8px 5px", "8px 5px"]}
            headerGap={true}
            filters={filters}
            highlightRules={highlightRules}
            customCellColor={(header, row) =>
                customCellColor(header, row, columnTypeMapping)
            }
            totalText="Overall Total"
            exportToExcelQuery={exportToExcelQuery}
        />
    );
};

export default CorporatePlansSummaryTable;
